import { render, staticRenderFns } from "./CartButton.vue?vue&type=template&id=d4869c48&"
import script from "./CartButton.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CartButton.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4869c48')) {
      api.createRecord('d4869c48', component.options)
    } else {
      api.reload('d4869c48', component.options)
    }
    module.hot.accept("./CartButton.vue?vue&type=template&id=d4869c48&", function () {
      api.rerender('d4869c48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/Analyses/components/AnalysisCard/components/CartButton.vue"
export default component.exports